var React = require('react');

function Industry (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 184v272a24 24 0 0 1-24 24H136a24 24 0 0 0 24-24V252.31l139.12-88.53A24 24 0 0 1 336 184v68.28l139.12-88.53A24 24 0 0 1 512 184z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M136 480H24a24 24 0 0 1-24-24V56a24 24 0 0 1 24-24h112a24 24 0 0 1 24 24v400a24 24 0 0 1-24 24z","className":"fa-primary","key":2})]);
}

Industry.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Industry;

Industry.default = Industry;
